import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { EmployeeGetApi } from "../Utils/Axios";

// Async thunk to fetch employee data
export const fetchEmployees = createAsyncThunk(
  "employees/fetchEmployees",
  async ({ page = null, size = null, search = "", branchId = "", status = "" } = {}, { rejectWithValue }) => {
    try {
      const response = await EmployeeGetApi(page, size, search, branchId, status);
      // Backend returns { status: "success", data: [...] } OR { status: "success", data: { data: [...], totalRecords: ... } }
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.data || "Something went wrong"
      );
    }
  }
);

// Employee slice
const employeeSlice = createSlice({
  name: "employees",
  initialState: {
    data: [],
    totalRecords: 0,
    totalPages: 0,
    currentPage: 0,
    pageSize: 10,
    status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployees.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchEmployees.fulfilled, (state, action) => {
        state.status = "succeeded";
        const payload = action.payload;
        if (payload?.data && typeof payload.data === 'object' && !Array.isArray(payload.data)) {
          // Paginated response
          state.data = payload.data.data || [];
          state.totalRecords = payload.data.totalRecords || 0;
          state.totalPages = payload.data.totalPages || 0;
          state.currentPage = payload.data.currentPage || 0;
          state.pageSize = payload.data.pageSize || 10;
        } else {
          // Simple list response
          state.data = payload?.data || [];
          state.totalRecords = state.data.length;
          state.totalPages = 1;
          state.currentPage = 0;
          state.pageSize = state.data.length || 10;
        }
        state.error = null;
      })
      .addCase(fetchEmployees.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to fetch employees";
      });
  },
});

export default employeeSlice.reducer;
